module.exports = __webpack_public_path__ + "static/media/vtex32.6f6f16e3.png";